module.exports = __webpack_public_path__ + "assets/img/pv-europe.4ac87b28.png";